import { map } from "lodash";
import { IoMenu } from "react-icons/io5";
import { BsArrowBarLeft } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Logo from "../../assets/logo_sin.svg";
import { administrationPages, navigationPages } from "../../app/pageMap";
import * as S from "./styles";
import Dropdown from "../Dropdown";
import history from "../../utils/history";
import getAllPermissionLogged from "../../utils/permissions";

export default function Navbar(props) {
  const { hideNavigation } = props;

  const [users, setUsers] = useState();
  const [userPermissions, setUserPermissions] = useState([]);
  const dispatch = useDispatch();
  const activeStyle = {
    color: "#012d5c",
    backgroundColor: "white",
  };

  const logout = () => {
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("tokenData");
    window.localStorage.removeItem("company");
    window.localStorage.removeItem("cnpjAgentSearch");
    window.localStorage.removeItem("pageAgentSearch");
    window.localStorage.removeItem("cnpjConvenioSearch");
    window.localStorage.removeItem("pageConvenioSearch");
    window.localStorage.removeItem("cpfPFSearch");
    window.localStorage.removeItem("pagePFSearch");
    window.localStorage.removeItem("cnpfPJSearch");
    window.localStorage.removeItem("pagePJSearch");
    window.localStorage.removeItem("cnpjRegionaisSearch");
    window.localStorage.removeItem("pageRegionaisSearch");
    window.localStorage.removeItem("cnpjLojaSearch");
    window.localStorage.removeItem("pageLojaSearch");
    window.localStorage.removeItem("cpfSearch");
    window.localStorage.removeItem("pageSearch");

    history.push("/");
  };

  useEffect(() => {
    const user = JSON.parse(window.localStorage.getItem("user") || "{}");

    setUserPermissions(getAllPermissionLogged());

    setUsers(user);
  }, []);
  const getContainsPermission = (
    permissionsByPage = [],
    permissionsByUser = []
  ) => {
    let existPermission = false;

    permissionsByPage.forEach((per) => {
      if (permissionsByUser.includes(per)) {
        existPermission = true;
      }
    });

    return existPermission;
  };

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const getSizeAndShowOrHideNavbar = () => {
    const widthWindow = window.innerWidth;
    if (widthWindow <= 978) {
      setSidebarOpen(false);
    }
  };
  useEffect(() => {
    getSizeAndShowOrHideNavbar();
  }, []);

  return (
    <>
      <S.Topbar>
        <S.ClosedNavbar>
          <button onClick={() => setSidebarOpen((prevState) => !prevState)}>
            <IoMenu size={20} style={{ color: "#fff" }} />
          </button>
        </S.ClosedNavbar>

        <S.UserInfos>
          <S.UserName status="userActive">
            Olá, <span>{users?.given_name}</span>
            <div className="wrapper_dropdown">
              <Dropdown
                tittle="Teste"
                items={administrationPages}
                permissions={userPermissions}
              />{" "}
            </div>
            <BsArrowBarLeft cursor={"pointer"} onClick={logout} size={20} />
          </S.UserName>
        </S.UserInfos>
      </S.Topbar>
      <S.Wrapper open={sidebarOpen}>
        <S.BoxLogo>
          <S.Image src={Logo} />
        </S.BoxLogo>

        <S.Nav>
          {!hideNavigation && (
            <>
              {map(navigationPages, (page) => {
                if (!getContainsPermission(page.permissions, userPermissions)) {
                  return null;
                }
                return (
                  <S.NavLinks
                    to={page.path}
                    activeStyle={activeStyle}
                    onClick={page.onNavigation && page.onNavigation(dispatch)}
                    forceIconCorrection={page.forceIconCorrection}
                  >
                    <S.SvgIcon src={page.icon} />
                    {page.title}
                  </S.NavLinks>
                );
              })}
            </>
          )}
        </S.Nav>
      </S.Wrapper>
    </>
  );
}
